(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1868],{

/***/ 47336:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/theatres",
      function () {
        return __webpack_require__(23662);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ theatres; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5447);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(99728);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(2746);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(1984);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./components/Layout/index.tsx + 12 modules
var Layout = __webpack_require__(46323);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./helpers/index.ts + 50 modules
var helpers = __webpack_require__(17651);
// EXTERNAL MODULE: ./hooks/index.ts + 3 modules
var hooks = __webpack_require__(22135);
// EXTERNAL MODULE: ./components/AppLink/AppLink.tsx
var AppLink = __webpack_require__(3245);
// EXTERNAL MODULE: ./components/DramoxImage/index.tsx
var DramoxImage = __webpack_require__(20010);
// EXTERNAL MODULE: ./components/TheatreSection/index.module.scss
var index_module = __webpack_require__(54666);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./enums/index.ts + 3 modules
var enums = __webpack_require__(39933);
;// CONCATENATED MODULE: ./components/TheatreSection/TheatreSection.tsx









var WITH_NUMBER = "_with-number";
var RowPlays = function(param) {
    var plays = param.plays, theatre = param.theatre, playsCount = param.playsCount, loadImages = param.loadImages;
    var ref = (0,react.useRef)(null);
    var lang = (0,useTranslation/* default */.Z)().lang;
    var ref1 = (0,react.useState)(), slicePlays = ref1[0], setSlicePlays = ref1[1];
    (0,hooks/* usePlayRow */.Yc)(ref, loadImages);
    (0,react.useEffect)(function() {
        var sliced = plays;
        if (playsCount > 4) {
            sliced = plays.slice(0, 4);
            sliced[3].title = WITH_NUMBER;
        }
        setSlicePlays(sliced);
    }, [
        plays,
        setSlicePlays
    ]);
    var getTileLink = function(play) {
        if (play.title === WITH_NUMBER) {
            return helpers/* Permalink.theatre */.xm.theatre(theatre);
        }
        return helpers/* Permalink.play */.xm.play(play, lang);
    };
    var getAnchorChild = function(play) {
        if (play.title === WITH_NUMBER) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "+",
                    theatre.plays_count - (slicePlays === null || slicePlays === void 0 ? void 0 : slicePlays.length) + 1
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DramoxImage/* default */.Z, {
                    loadImmediately: loadImages,
                    width: 170,
                    height: 96,
                    usePlaceholder: true,
                    src: play.poster_url,
                    alt: play.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    children: (0,helpers/* truncateTitle */.ew)(play.title)
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "theatre-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "category-section theatre-section",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref,
                className: "scroll-wrapper-theatre",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "play-list swiper-wrapper",
                    children: slicePlays === null || slicePlays === void 0 ? void 0 : slicePlays.map(function(play) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            className: [
                                (play === null || play === void 0 ? void 0 : play.title) === WITH_NUMBER ? "with-number" : "",
                                "swiper-slide"
                            ].join(" "),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                href: getTileLink(play),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: getAnchorChild(play)
                                })
                            })
                        }, play.id);
                    })
                })
            })
        })
    });
};
var TheartreSection = function(param) {
    var theatre = param.theatre;
    var ref;
    var ref1 = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(null), elementTop = ref2[0], setElementTop = ref2[1];
    var t = (0,useTranslation/* default */.Z)(enums/* Namespace.Theaters */.lS.Theaters).t;
    (0,react.useEffect)(function() {
        if (ref1 === null || ref1 === void 0 ? void 0 : ref1.current) {
            var ref;
            // calculate top only once on initial render
            setElementTop(ref1 === null || ref1 === void 0 ? void 0 : (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().top);
        }
    }, [
        ref1
    ]);
    var loadImages = (0,hooks/* useOnScrollElement */.Vq)(elementTop);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        ref: ref1,
        className: [
            (index_module_default()).theatreRow,
            (index_module_default()).withBackground
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).info,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                        href: helpers/* Permalink.theatre */.xm.theatre(theatre),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: theatre.poster_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DramoxImage/* default */.Z, {
                                width: 48,
                                placeholderClass: (index_module_default()).imgPlaceholder,
                                height: 48,
                                alt: theatre === null || theatre === void 0 ? void 0 : theatre.name,
                                loadImmediately: loadImages,
                                usePlaceholder: true,
                                src: theatre === null || theatre === void 0 ? void 0 : theatre.poster_url
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (index_module_default()).imgPlaceholder,
                                children: theatre === null || theatre === void 0 ? void 0 : (ref = theatre.name) === null || ref === void 0 ? void 0 : ref.substr(0, 1)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_module_default()).text,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                    href: helpers/* Permalink.theatre */.xm.theatre(theatre),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: theatre === null || theatre === void 0 ? void 0 : theatre.name
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("plays_count_".concat((0,helpers/* determinePluralFromNumber */["in"])(theatre === null || theatre === void 0 ? void 0 : theatre.plays_count)), {
                                    count: theatre === null || theatre === void 0 ? void 0 : theatre.plays_count
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowPlays, {
                playsCount: theatre === null || theatre === void 0 ? void 0 : theatre.plays_count,
                theatre: theatre,
                plays: theatre.plays.map(function(p) {
                    return Object.assign({}, p, {
                        theatre: theatre
                    });
                }),
                loadImages: loadImages
            })
        ]
    }, theatre.id);
};
/* harmony default export */ var TheatreSection = (TheartreSection);

// EXTERNAL MODULE: ./enums/namespaces.ts
var namespaces = __webpack_require__(99731);
// EXTERNAL MODULE: ./pages/theatres/index.module.scss
var theatres_index_module = __webpack_require__(89269);
var theatres_index_module_default = /*#__PURE__*/__webpack_require__.n(theatres_index_module);
// EXTERNAL MODULE: ./context/index.ts + 2 modules
var context = __webpack_require__(52662);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(62139);
;// CONCATENATED MODULE: ./models/PopularTheatre.ts

var PopularTheatre = /*#__PURE__*/ function() {
    "use strict";
    function PopularTheatre() {
        (0,_class_call_check/* default */.Z)(this, PopularTheatre);
    }
    var _proto = PopularTheatre.prototype;
    _proto.getPopularPlay = function getPopularPlay(id) {
        return this.most_popular_plays.find(function(play) {
            return play.theatre === id;
        });
    };
    PopularTheatre.fromJSON = function fromJSON(json) {
        return Object.assign(new PopularTheatre(), json);
    };
    return PopularTheatre;
}();
/* harmony default export */ var models_PopularTheatre = (PopularTheatre);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(75657);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./context/langContext.ts
var langContext = __webpack_require__(70082);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(60950);
// EXTERNAL MODULE: ./components/FavoriteTheatres/index.module.scss
var FavoriteTheatres_index_module = __webpack_require__(86999);
var FavoriteTheatres_index_module_default = /*#__PURE__*/__webpack_require__.n(FavoriteTheatres_index_module);
;// CONCATENATED MODULE: ./components/FavoriteTheatres/index.tsx









var FavoriteTheatres = function(param) {
    var favoriteTheatres = param.favoriteTheatres;
    var t = (0,useTranslation/* default */.Z)(enums/* Namespace.Theaters */.lS.Theaters).t;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(true), showSkeleton = ref1[0], setShowSkeleton = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        var onLoad = function() {
            setShowSkeleton(false);
        };
        var url = (ref = favoriteTheatres[0]) === null || ref === void 0 ? void 0 : ref.poster_url;
        if (url) {
            var img = new Image();
            img.onload = onLoad;
            img.onerror = onLoad;
            img.src = url;
        } else {
            onLoad();
        }
    }, [
        favoriteTheatres,
        setShowSkeleton
    ]);
    (0,hooks/* useTheatreRow */.qM)(ref, showSkeleton);
    var arr = Array.from({
        length: 10
    }, function(v, i) {
        return i;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (FavoriteTheatres_index_module_default()).favoriteTheatres
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: t("popular_this_week_theatres")
            }),
            showSkeleton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SkeletonTheme */.y, {
                baseColor: "#22222E",
                highlightColor: "rgba(72, 72, 72, 0.48)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (FavoriteTheatres_index_module_default()).skeleton,
                    children: arr.map(function(_, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (FavoriteTheatres_index_module_default()).number,
                                    children: i + 1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (FavoriteTheatres_index_module_default()).circle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        style: {
                                            height: "100%",
                                            width: "100%",
                                            borderRadius: 48
                                        },
                                        duration: 2
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (FavoriteTheatres_index_module_default()).rows,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (FavoriteTheatres_index_module_default()).firstRow,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                style: {
                                                    height: "100%",
                                                    width: "100%",
                                                    borderRadius: 3
                                                },
                                                duration: 2
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (FavoriteTheatres_index_module_default()).secondRow,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                style: {
                                                    height: "100%",
                                                    width: "100%",
                                                    borderRadius: 3
                                                },
                                                duration: 2
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref,
                className: "scroll-wrapper-theatre",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: [
                        "play-list",
                        "swiper-wrapper",
                        (FavoriteTheatres_index_module_default()).favorites
                    ].join(" "),
                    children: favoriteTheatres === null || favoriteTheatres === void 0 ? void 0 : favoriteTheatres.map(function(pop, i) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            className: "swiper-slide",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: helpers/* Permalink.theatre */.xm.theatre(pop),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (FavoriteTheatres_index_module_default()).order,
                                            children: i + 1
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                background: "url(".concat(pop.poster_url, ")")
                                            },
                                            className: (FavoriteTheatres_index_module_default()).favLogo
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (FavoriteTheatres_index_module_default()).favWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: pop.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: t("plays_count_".concat((0,helpers/* determinePluralFromNumber */["in"])(pop === null || pop === void 0 ? void 0 : pop.plays_count)), {
                                                        count: pop === null || pop === void 0 ? void 0 : pop.plays_count
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, i);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_FavoriteTheatres = (FavoriteTheatres);

// EXTERNAL MODULE: ./components/Select/Select.tsx
var Select = __webpack_require__(53173);
;// CONCATENATED MODULE: ./enums/sortType.ts
var SortTheatreType;
(function(SortTheatreType) {
    SortTheatreType["Name"] = "name";
    SortTheatreType["Created"] = "created";
    SortTheatreType["Popularity"] = "popularity";
})(SortTheatreType || (SortTheatreType = {}));

// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(66564);
// EXTERNAL MODULE: ./external/swiper/js/swiper.esm.bundle.js + 2 modules
var swiper_esm_bundle = __webpack_require__(48408);
;// CONCATENATED MODULE: ./pages/theatres/index.tsx




// @ts-ignore




















var DEFAULT_FILTERS = {
    order_by: SortTheatreType.Popularity,
    play_genre: -1,
    play_language: "",
    plays_count: true,
    include_plays: 4
};
var Theaters = function(param) {
    var theatres = param.theatres, countryCode = param.countryCode, popularTheatres = param.popularTheatres, theatresFilters = param.theatresFilters, defaultSelectedCountry = param.defaultSelectedCountry;
    var ref;
    var t = (0,useTranslation/* default */.Z)(namespaces/* Namespace.Theaters */.l.Theaters).t;
    var ref1 = (0,react.useRef)(null);
    var filterRef = (0,react.useRef)(null);
    var popularRef = (0,react.useRef)(null);
    var locale = (0,langContext/* useLang */.J)().locale;
    var ref2 = (0,react.useState)(theatres), localTheatres = ref2[0], setLocalTheatres = ref2[1];
    var ref3 = (0,react.useState)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, DEFAULT_FILTERS), {
        play_country: defaultSelectedCountry
    })), filters = ref3[0], setFilters = ref3[1];
    var ref4 = (0,react.useState)(false), filterScrolled = ref4[0], setFilterScrolled = ref4[1];
    var ref5 = (0,react.useState)(false), isMobileState = ref5[0], setMobileState = ref5[1];
    var isMobile = (0,react.useRef)(isMobileState);
    var filterSwiper = (0,react.useRef)();
    var ref6 = (0,react.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var popular = models_PopularTheatre.fromJSON(popularTheatres);
    (0,react.useEffect)(function() {
        if (theatres.length > 0 && !loading) {
            var onLoad = function() {
                setLoading(false);
            };
            var img = new Image();
            img.onload = onLoad;
            img.onerror = onLoad;
            img.src = theatres[0].poster_url;
        }
    }, [
        theatres,
        loading
    ]);
    (0,hooks/* useTheatreRow */.qM)(ref1);
    (0,react.useEffect)(function() {
        if (!(0,helpers/* isServer */.sk)()) {
            var originalPosition = filterRef.current.getBoundingClientRect().y + document.documentElement.scrollTop;
            var header = document.querySelector("header");
            var handleScrollFilter = function() {
                if (isMobile.current) {
                    var scrolled = document.scrollingElement.scrollTop;
                    // scrolled position + height of header
                    if (scrolled + 64 > originalPosition) {
                        setFilterScrolled(isMobile.current && scrolled + 64 > originalPosition);
                        header.classList.add("solid-header");
                    } else {
                        header.classList.remove("solid-header");
                        setFilterScrolled(isMobile.current && false);
                    }
                } else {
                    setFilterScrolled(false);
                }
            };
            var debouncedScroll = (0,helpers/* debounce */.Ds)(handleScrollFilter, 10);
            window.addEventListener("scroll", debouncedScroll, false);
            return function() {
                window.removeEventListener("scroll", debouncedScroll);
            };
        }
    }, [
        filterRef,
        setFilterScrolled,
        setMobileState,
        popularRef
    ]);
    (0,react.useEffect)(function() {
        if (!(0,helpers/* isServer */.sk)()) {
            var handleResize = function() {
                setMobileState((0,helpers/* isMobileView */.lZ)());
                isMobile.current = (0,helpers/* isMobileView */.lZ)();
            };
            window.addEventListener("resize", handleResize, false);
            handleResize();
            return function() {
                window.removeEventListener("resize", handleResize);
            };
        }
    }, []);
    (0,react.useEffect)(function() {
        if (isMobile.current) {
            filterSwiper.current = new swiper_esm_bundle/* default */.Z(filterRef.current, {
                direction: "horizontal",
                slidesPerView: "auto",
                observeParents: true,
                observer: true,
                freeMode: true,
                updateOnWindowResize: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                }
            });
        } else {
            if (filterSwiper.current) {
                filterSwiper.current.detachEvents();
                filterSwiper.current.destroy(true, true);
                filterSwiper.current = null;
            }
        }
    }, [
        isMobileState
    ]);
    var updateTheatres = (0,react.useCallback)(function(query) {
        var tempQuery = (0,_object_spread/* default */.Z)({}, query);
        Object.keys(tempQuery).forEach(function(key) {
            if (tempQuery[key] === -1 || tempQuery[key] === "") {
                delete tempQuery[key];
            }
        });
        setLoading(true);
        (0,client/* getSharedApiClient */.L)().getTheatres(tempQuery).then(function(values) {
            // custom sorting in case of SortTheatreType.Created: we want the newest performances first + related theatres
            if (tempQuery.order_by === SortTheatreType.Created) {
                values = values.sort(function(theatreA, theatreB) {
                    var sortPlays = function sortPlays(a, b) {
                        return a.id > b.id ? -1 : 1;
                    };
                    var ref = (0,_sliced_to_array/* default */.Z)([
                        theatreA,
                        theatreB
                    ].map(function(t) {
                        return t.plays.sort(sortPlays)[0];
                    }), 2), playA = ref[0], playB = ref[1];
                    return playA.id > playB.id ? -1 : 1;
                });
            }
            setLocalTheatres(values);
            setLoading(false);
        });
    }, [
        setLocalTheatres,
        client/* getSharedApiClient */.L,
        setLoading
    ]);
    (0,react.useEffect)(function() {
        updateTheatres(filters);
    }, []);
    var onFilterChanged = (0,react.useCallback)(function(newValue) {
        var reset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, index = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var temp = (0,_object_spread/* default */.Z)({}, filters, newValue);
        setFilters(temp);
        updateTheatres(temp);
        if (reset) {
            window.scrollTo(0, 0);
        }
        if (filterSwiper.current) {
            var timeout = setTimeout(function() {
                filterSwiper.current.update();
                filterSwiper.current.slideTo(index);
                clearTimeout(timeout);
            }, 50);
        }
    }, [
        setFilters,
        filters,
        updateTheatres
    ]);
    var hasFilters = (0,react.useMemo)(function() {
        if (filters.order_by === SortTheatreType.Name && (filters === null || filters === void 0 ? void 0 : filters.play_country) === -1 && (filters === null || filters === void 0 ? void 0 : filters.play_language) === "" && filters.play_genre === -1) {
            return false;
        }
        return true;
    }, [
        filters
    ]);
    var sortValues = (0,react.useMemo)(function() {
        return [
            {
                value: SortTheatreType.Name,
                label: "".concat(t("sort_alphabeticaly"))
            },
            {
                value: SortTheatreType.Created,
                label: "".concat(t("sort_newest"))
            },
            {
                value: SortTheatreType.Popularity,
                label: "".concat(t("sort_popular"))
            }, 
        ];
    }, []);
    var genresValues = (0,react.useMemo)(function() {
        var ref;
        return [
            {
                value: -1,
                label: t("filter_all")
            }
        ].concat((ref = theatresFilters.genres) === null || ref === void 0 ? void 0 : ref.map(function(genre) {
            return {
                value: genre.id,
                label: genre.name
            };
        }));
    }, [
        theatresFilters
    ]);
    var languageValues = (0,react.useMemo)(function() {
        var ref;
        return [
            {
                value: "",
                label: t("filter_all")
            }
        ].concat((ref = theatresFilters.languages) === null || ref === void 0 ? void 0 : ref.map(function(lang) {
            return {
                value: lang.code,
                label: lang.title
            };
        }));
    }, [
        theatresFilters
    ]);
    var countryValues = (0,react.useMemo)(function() {
        var ref;
        return [
            {
                value: -1,
                label: t("filter_all")
            }
        ].concat((ref = theatresFilters.countries) === null || ref === void 0 ? void 0 : ref.map(function(country) {
            return {
                value: country.id,
                label: country.title
            };
        }));
    }, [
        theatresFilters
    ]);
    var skeletonRows = Array.from({
        length: 3
    }, function(v, i) {
        return i;
    });
    var skeletonSlides = Array.from({
        length: 4
    }, function(v, i) {
        return i;
    });
    var theaterSkeleton = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SkeletonTheme */.y, {
            baseColor: "#22222E",
            highlightColor: "rgba(72, 72, 72, 0.48)",
            children: skeletonRows.map(function(i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: (theatres_index_module_default()).skeletonRow,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (theatres_index_module_default()).wrap,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (theatres_index_module_default()).circle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        duration: 2,
                                        style: {
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: 48
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (theatres_index_module_default()).first,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                duration: 2,
                                                style: {
                                                    width: "100%",
                                                    height: "100%",
                                                    borderRadius: 3
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (theatres_index_module_default()).second,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                duration: 2,
                                                style: {
                                                    width: "100%",
                                                    height: "100%",
                                                    borderRadius: 3
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: (theatres_index_module_default()).slides,
                            children: skeletonSlides.map(function(j) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (theatres_index_module_default()).slide,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                duration: 2,
                                                style: {
                                                    width: "100%",
                                                    height: "100%",
                                                    borderRadius: 6
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (theatres_index_module_default()).slideDesc,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                duration: 2,
                                                style: {
                                                    width: "100%",
                                                    height: "100%",
                                                    borderRadius: 6
                                                }
                                            })
                                        })
                                    ]
                                }, j);
                            })
                        })
                    ]
                }, i);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: (0,helpers/* basicSEO */.Fi)(t("seo:theatres_title"), t("seo:theatres_description"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: (theatres_index_module_default()).theatres,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: t("most_popular_theatres")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: ref1,
                        className: [
                            "scroll-wrapper-theatre",
                            (theatres_index_module_default()).popularWrapper
                        ].join(" "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: [
                                "play-list",
                                "swiper-wrapper",
                                (theatres_index_module_default()).mostPopular
                            ].join(" "),
                            children: popular === null || popular === void 0 ? void 0 : (ref = popular.most_popular_theatres) === null || ref === void 0 ? void 0 : ref.map(function(theater) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                    className: "swiper-slide",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: helpers/* Permalink.theatre */.xm.theatre(theater, locale),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DramoxImage/* default */.Z, {
                                                    usePlaceholder: true,
                                                    alt: theater.name,
                                                    width: 12000,
                                                    height: 290,
                                                    src: popular.getPopularPlay(theater.id).poster_url
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (theatres_index_module_default()).text,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                background: "url(".concat(theater.poster_url, ")")
                                                            },
                                                            className: (theatres_index_module_default()).theaterLogo
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: (theatres_index_module_default()).theaterName,
                                                            children: theater.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (theatres_index_module_default()).playsCount,
                                                            children: t("plays_count_".concat((0,helpers/* determinePluralFromNumber */["in"])(theater === null || theater === void 0 ? void 0 : theater.plays_count)), {
                                                                count: theater === null || theater === void 0 ? void 0 : theater.plays_count
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }, theater.id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (theatres_index_module_default()).columns,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FavoriteTheatres, {
                                favoriteTheatres: popular === null || popular === void 0 ? void 0 : popular.this_week
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                ref: popularRef,
                                className: [
                                    (theatres_index_module_default()).theatresWrapper
                                ].join(" "),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (theatres_index_module_default()).theatresHeader,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: t("dramox_theatres")
                                            }),
                                            hasFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                onClick: function() {
                                                    onFilterChanged((0,_object_spread/* default */.Z)({}, DEFAULT_FILTERS), true);
                                                },
                                                children: t("clear_filter")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: filterRef,
                                        className: [
                                            "scroll-wrapper-theatre",
                                            (theatres_index_module_default()).filters,
                                            filterScrolled ? (theatres_index_module_default()).onScrolled : ""
                                        ].join(" "),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "play-list swiper-wrapper",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onMouseMove: function(e) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                    },
                                                    className: "swiper-slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "sort",
                                                                children: t("sort")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: sortValues.find(function(ff) {
                                                                    return ff.value === filters.order_by;
                                                                }).label
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                                className: (theatres_index_module_default()).select,
                                                                value: filters.order_by,
                                                                name: "sort",
                                                                onChange: function(val) {
                                                                    onFilterChanged({
                                                                        order_by: val
                                                                    }, false, 0);
                                                                },
                                                                options: sortValues
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "swiper-slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "genre",
                                                                children: t("genre")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: genresValues.find(function(ff) {
                                                                    return ff.value === filters.play_genre;
                                                                }).label
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                                className: (theatres_index_module_default()).select,
                                                                value: filters.play_genre,
                                                                name: "genre",
                                                                onChange: function(val) {
                                                                    onFilterChanged({
                                                                        play_genre: parseInt(val)
                                                                    }, false, 1);
                                                                },
                                                                options: genresValues
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "swiper-slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "play_language",
                                                                children: t("language")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: languageValues.find(function(ff) {
                                                                    return ff.value === filters.play_language;
                                                                }).label
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                                className: (theatres_index_module_default()).select,
                                                                value: filters.play_language,
                                                                name: "play_language",
                                                                onChange: function(val) {
                                                                    onFilterChanged({
                                                                        play_language: val
                                                                    }, false, 2);
                                                                },
                                                                options: languageValues
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "swiper-slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "country",
                                                                children: t("country")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: countryValues.find(function(ff) {
                                                                    return ff.value === filters.play_country;
                                                                }).label
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                                className: (theatres_index_module_default()).select,
                                                                value: filters.play_country,
                                                                name: "country",
                                                                onChange: function(val) {
                                                                    onFilterChanged({
                                                                        play_country: parseInt(val)
                                                                    }, false, 3);
                                                                },
                                                                options: countryValues
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (theatres_index_module_default()).theatres,
                                        children: [
                                            loading && theaterSkeleton(),
                                            localTheatres.length > 0 && localTheatres.map(function(theatre, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TheatreSection, {
                                                    theatre: theatre
                                                }, i);
                                            }),
                                            !loading && localTheatres.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: (theatres_index_module_default()).emptyState,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (theatres_index_module_default()).img
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: t("no_theatres")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#",
                                                        onClick: function(e) {
                                                            e.preventDefault();
                                                            onFilterChanged((0,_object_spread/* default */.Z)({}, DEFAULT_FILTERS), true);
                                                        },
                                                        children: t("clear_filter")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var theatres = ((0,context/* withForcePlanToLoggedInUnsubs */.DE)(Theaters));


/***/ }),

/***/ 86999:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"favoriteTheatres":"FavoriteTheatres_favoriteTheatres__5__Dy","favorites":"FavoriteTheatres_favorites__d0wff","order":"FavoriteTheatres_order__WBFDC","favLogo":"FavoriteTheatres_favLogo__69lK3","favWrapper":"FavoriteTheatres_favWrapper__2OFWX","fixed":"FavoriteTheatres_fixed__QHV33","skeleton":"FavoriteTheatres_skeleton__qV_gK","number":"FavoriteTheatres_number__kKTER","circle":"FavoriteTheatres_circle__3sdSq","rows":"FavoriteTheatres_rows__rU4j6","firstRow":"FavoriteTheatres_firstRow__1aiR4","secondRow":"FavoriteTheatres_secondRow__mLDdx"};

/***/ }),

/***/ 54666:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"theatreRow":"TheatreSection_theatreRow__qgWKJ","info":"TheatreSection_info__gylyW","imgPlaceholder":"TheatreSection_imgPlaceholder__xrQY7","text":"TheatreSection_text__Pu7uQ","withBackground":"TheatreSection_withBackground__oYOmc"};

/***/ }),

/***/ 89269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"theatres":"theatres_theatres__rchoL","popularWrapper":"theatres_popularWrapper__tiadV","mostPopular":"theatres_mostPopular__4D2K3","text":"theatres_text__GM09h","theaterLogo":"theatres_theaterLogo__RrdTA","theaterName":"theatres_theaterName__EtZd7","playsCount":"theatres_playsCount__SsFo6","columns":"theatres_columns__Jg6vE","theatresWrapper":"theatres_theatresWrapper__S5OT9","theatresHeader":"theatres_theatresHeader__sPaDr","filters":"theatres_filters__ijc3f","select":"theatres_select__eFNBl","onScrolled":"theatres_onScrolled__uQTw5","onRight":"theatres_onRight__Qn3vE","emptyState":"theatres_emptyState__kp7mG","img":"theatres_img__Ru579","skeletonRow":"theatres_skeletonRow__4UFgO","wrap":"theatres_wrap__xzUag","circle":"theatres_circle__TM9wM","first":"theatres_first___TDCB","second":"theatres_second__dmVRB","slides":"theatres_slides__Db9s4","slide":"theatres_slide__eF6ye","slideDesc":"theatres_slideDesc__DfUEa","placeholderHidden":"theatres_placeholderHidden__wdGu3"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(47336); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);